import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = ["src"];
import { watchEffect, ref, nextTick } from '../../../../adapter-vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-face',
  props: {
    content: {
      type: Object,
      default: () => ({})
    },
    isPC: {
      type: Boolean,
      default: false
    }
  },
  setup(__props) {
    var props = __props;
    var data = ref();
    var imgurl = ref('');
    var skeleton = ref();
    watchEffect(() => {
      data.value = props.content;
      // console.log("data.url---", data.value)
      var whitelist = ['01-就这么拌.jpg', '02-hello我来啦.jpg', '04-达成一致.jpg', '05-OK.jpg', '06-谢谢.jpg', '07-加油.jpg', '09-我顶得住.jpg', '10-努力工作.jpg', '12-效率起飞.jpg', '13-加载中.jpg', '14-你细品.jpg', '15-安全供货.jpg', '乘风破浪.jpg', '果断出手.jpg', '收到.jpg', '我膨胀了.jpg'];
      var count = 0;
      for (var i in whitelist) {
        if (data.value.url.includes(whitelist[i])) {
          // console.log("whitelist[i]-->", whitelist[i]);
          count += 1;
          imgurl.value = 'https://www.bio-cloud.com.cn:8022/icon/' + whitelist[i];
        }
      }
      if (count < 1) {
        imgurl.value = data.value.url;
      }
      if (!data.value) return;
      nextTick(() => {
        // todo 大小显示
      });
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "skeleton",
        ref: skeleton,
        class: "message-image"
      }, [_createElementVNode("img", {
        class: "message-image",
        src: _unref(imgurl)
      }, null, 8, _hoisted_1)], 512);
    };
  }
});